import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;
const TOKEN_KEY = "pp_session_token";

export function getStoredToken() {
  try {
    return window.localStorage.getItem(TOKEN_KEY) || null;
  } catch {
    return null;
  }
}

export function setStoredToken(token) {
  try {
    if (token) window.localStorage.setItem(TOKEN_KEY, token);
    else window.localStorage.removeItem(TOKEN_KEY);
  } catch {
    /* localStorage may be disabled — fall through */
  }
}

export function clearStoredToken() {
  setStoredToken(null);
}

export const api = axios.create({
  baseURL: API_BASE,
  // Production ingress strips credentialed Set-Cookie headers AND returns
  // `Access-Control-Allow-Origin: *` which browsers reject when paired with
  // credentials. We rely on Authorization: Bearer (set via interceptor below)
  // and turn off cookie credentials — auth still works cleanly cross-origin.
  withCredentials: false,
  timeout: 15000,
});

// Attach Authorization: Bearer <token> on every request so auth works even when
// the production ingress strips the credentialed Set-Cookie. Cookies stay as a
// fallback for environments where they do persist.
api.interceptors.request.use((config) => {
  const token = getStoredToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
